const postBookingPaymentModel =
    require('../../../webapp/static-content/_versionedByRelease_/js/modules/models/post_booking_payment.model').getInstance();
const products = new Odigeo.Enum(['seats', 'bags']);
const seatsUrl = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('addSeats');
const ecommerceUrl = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('getSeatsEcommerceData');
const trackingUtils = require('od-modules/utils/tracking.utils');
const myTripsUtils = require('od-modules/utils/my_trips.utils');
const responseToEventError = {
    CC_ERR: 'purchasePaymentError',
    PAY_ERR: 'purchasePaymentError',
    SEAT_SEL_ERR: 'purchaseError',
    VAL_ERR: 'purchaseError',
    UPDATE_WNG: 'purchaseOk',
    PROV_WNG: 'purchaseOk',
};
const errorTypeForTracking = {
    INVALID_CARD_NUMBER: 'cccard_number_submit_invalid_error',
    WRONG_CVV2: 'cccard_cvv_submit_invalid_error',
    WRONG_CREDITCARD_EXPIRATION_DATE: 'cccard_expiration_submit_invalid_errors',
    CARD_EXPIRED: 'cccard_expiration_submit_invalid_errors',
    DATA_VALIDATION_ERROR: 'cccard_owner_submit_invalid_error',
    UNKNOWN: 'other',
};
let bookingInfo;

module.exports = {
    setCardData(paymentDetails) {
        postBookingPaymentModel.set('paymentDetails', paymentDetails);
    },
    getPaymentDetails() {
        return postBookingPaymentModel.get('paymentDetails');
    },
    buildSeatSelectionRequest(seatSelection) {
        const seatFee = seatSelection.totalPrice - seatSelection.providerPrice;
        return {
            seatMapRow: seatSelection.seatMapRow,
            column: seatSelection.columnSelection,
            row: seatSelection.rowSelection,
            floor: seatSelection.floorSelection,
            section: seatSelection.section,
            totalPrice: {
                amount: seatSelection.totalPrice.toFixed(2),
                currencyCode: seatSelection.currencyCode,
            },
            seatFee: {
                amount: seatFee.toFixed(2),
                currencyCode: seatSelection.currencyCode,
            },
        };
    },
    buildTravelerSeatsSelectionRequest(travellerNumber, travelerSeatsSelection) {
        const seatMapSelectionList = travelerSeatsSelection.map(this.buildSeatSelectionRequest);
        return {
            travellerNumber,
            seatMapSelectionList,
        };
    },
    buildAncillarySelectionList(seatsSelection) {
        const seatsSelectionByTraveler = Odigeo._.groupBy(seatsSelection.toJSON(), 'numPassenger');
        return Odigeo._.reduce(seatsSelectionByTraveler, (travellersSelection, currentTravellerSelection, travelerIndex) => {
            travellersSelection.push(this.buildTravelerSeatsSelectionRequest(travelerIndex, currentTravellerSelection));
            return travellersSelection;
        }, []);
    },
    buildSeatsRequest(seatsSelection, postBookingPaymentModel) {
        const creditCardDetails = postBookingPaymentModel.get('paymentDetails').creditCardDetails;
        const seatsByTravelerRequest = this.buildAncillarySelectionList(seatsSelection);

        return {
            ancillarySelectionList: seatsByTravelerRequest,
            chargeBookingRequest: {
                amount: {
                    amount: seatsSelection.getTotalPrice().toFixed(2),
                    currencyCode: seatsSelection.getCurrencyCode(),
                },
                collectionCurrency: seatsSelection.getCurrencyCode(),
                collectionParameters: {
                    creditCardCollectionParameters: {
                        typeInfo: 'creditCardCollectionParameters',
                        typeCode: creditCardDetails.typeCode,
                        owner: creditCardDetails.owner,
                        number: creditCardDetails.number,
                        expiryDate: creditCardDetails.expirationMonth + creditCardDetails.expirationYear,
                        cvv2: creditCardDetails.securityNumber,
                    },
                },
            },
        };
    },
    purchaseSeats(checkinSeatsCollection, bookingId, widgetId) {
        const data = this.buildSeatsRequest(checkinSeatsCollection, postBookingPaymentModel);
        this.purchaseProduct(products.seats, seatsUrl, data, bookingId, widgetId);
    },
    purchaseProduct(productId, url, paymentData, bookingId, widgetId) {
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            url: `${url}/${bookingId}`,
            type: 'POST',
            data: JSON.stringify(paymentData),
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this, widgetId, productId),
            error: Odigeo._.bind(this.requestErrorHandler, this, widgetId, productId),
            timeout: 60000,
        });
    },
    requestSuccessHandler(widgetId, product, response) {
        if (!Odigeo._.isEmpty(response.errors)) {
            const error = response.errors[0];
            this.checkinTrackPaymentError(response);
            Odigeo.trigger(`${widgetId}:purchaseError`, product, error.message);
        } else {
            const res = response.addAncillariesResponseDTO;
            if (res.success) {
                this.checkinTrackPaymentSuccess(response, res);
                Odigeo.trigger(`${widgetId}:purchaseOk`, product);
            } else {
                this.checkinTrackPaymentError(res);
                Odigeo.trigger(`${widgetId}:${(responseToEventError[res.code] || 'purchaseError')}`, product);
            }
        }
    },

    requestErrorHandler(widgetId, product, response) {
        Odigeo.trigger(`${widgetId}:purchaseError`, product, response);
        this.checkinTrackPaymentError();
    },

    checkinTrackPaymentSuccess(response = {}, res = null) {
        bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        let result;
        if (res && res.code) {
            result = res.code === 'PROV_WNG' ? 'manual' : 'robot';
        } else {
            result = 'OK';
        }

        const label = myTripsUtils.checkinMfTracking(bookingInfo,
            'checkinOnPaymentSuccess',
            `pay-success-${result}_checkin`);
        trackingUtils.trackEcommerce(response.analyticsEcommerce, 'postBookingAncillaries');
        this._trackPage('seat', 'confirmation');
        this._trackEvent('pb_checkin_seatconf_page', 'checkin_seat', label);
    },

    checkinTrackPaymentError(response = {}) {
        bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const result = Odigeo._.contains(response.message, errorTypeForTracking[response.code]) || errorTypeForTracking['UNKNOWN'];
        const label = myTripsUtils.checkinMfTracking(bookingInfo, 'checkinOnPaymentError', `pay-fail-${result}_checkin`);
        this._trackPage('seat', 'error');
        this._trackPage('seat', 'payment');
        this._trackEvent('pb_checkin_seatconf_page', 'checkin_seat', label);
    },

    checkinTrackPaymentSuccessOneClickCheckout(checkinSeatsCollection, bookingId) {
        const data = this.buildSeatsRequest(checkinSeatsCollection, postBookingPaymentModel);
        // eslint-disable-next-line no-restricted-properties
        $.ajax({
            url: `${ecommerceUrl}/${bookingId}`,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.ecommerceRequestSuccessHandler, this),
            timeout: 60000,
        });
    },

    ecommerceRequestSuccessHandler(response) {
        bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const label = myTripsUtils.checkinMfTracking(bookingInfo,
            'checkinOnPaymentSuccess',
            `pay-success-OK_checkin`);
        trackingUtils.trackEcommerce(response, 'postBookingAncillaries');
        this._trackPage('seat', 'confirmation');
        this._trackEvent('pb_checkin_seatconf_page', 'checkin_seat', label);
    },

    _trackPage: function(page, childPage = null) {
        const subPage = childPage ? `/${childPage}` : '';
        trackingUtils.trackPage(`PB/check-in/${page}${subPage}`, {
            funnel: false,
        });
    },

    _trackEvent: function(category, action, label) {
        trackingUtils.trackEventWithCategory(category, action, label);
    },
};
